export const loader = document.querySelector('.loader__backdrop');

